import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { list as getList, reset as resetList } from '../actions/delivery/list';
import { create, success } from '../actions/delivery/create';
import { close } from '../actions/modal/deliveryForm';
import { State } from '../types/store';
import { computeProductArray, computeSubmitData, getProductList, handleCheckBox, ProductSelectionProps, ProductSelectionState, ProductShell, updateDataTable } from '../utils/documentModalCommon';
import ProductSelectionModal from './ProductSelectionModal';
import { DeliveryForm } from '../types/document';

class DeliveryFormModal
  extends React.Component<ProductSelectionProps<DeliveryForm>, ProductSelectionState> {
  state: ProductSelectionState = {
    addProducts: false,
    arrayProducts: [],
    dataTable: [],
    documents: [],
    documentsOut: [],
    errorSelectedProducts: false,
    selectedProducts: [],
  };

  componentDidMount(): void {
    const { getList, selectedDocument, selectedCompany } = this.props;

    getList(`/delivery_forms?company=${selectedCompany.id}&invoice=${selectedDocument.id}`);

    this.setState({
      arrayProducts: getProductList(selectedDocument),
    });
  }

  static getDerivedStateFromProps(
    nProps: ProductSelectionProps<DeliveryForm>,
    pState: ProductSelectionState,
  ): Partial<ProductSelectionState> {
    if (!isEmpty(nProps.list) && nProps.list['hydra:member'] !== pState.documentsOut) {
      return {
        documents: nProps.list['hydra:member'],
        documentsOut: nProps.list['hydra:member'],
      };
    }

    // tslint:disable-next-line:no-null-keyword
    return {};
  }

  componentDidUpdate(
    prevProps: ProductSelectionProps<DeliveryForm>,
    prevState: ProductSelectionState,
  ): void {
    const { success } = this.props;
    const { documents } = this.state;

    if (!isEmpty(success) && success !== prevProps.success) {
      this.refreshList();
    }

    if (documents && documents !== prevState.documents) {
      this.updateDocument();
    }
  }

  componentWillUnmount(): void {
    const { reset } = this.props;
    reset();
  }

  updateDocument = (): void => {
    const { documents, arrayProducts } = this.state;

    const dataTable = updateDataTable(documents, arrayProducts);

    this.setState({
      dataTable,
    });
  };

  refreshList = (): void => {
    const { success } = this.props;
    const { documents } = this.state;
    const newData = documents.concat(success);

    this.setState({
      addProducts: false,
      selectedProducts: [],
      documents: newData,
    });
  };

  handleInputChange = (e: any, index: number, diff: string): void => {
    e.preventDefault();
    const { selectedProducts } = this.state;

    const products = computeProductArray(e.target.value, selectedProducts, index, diff);

    this.setState({
      selectedProducts: products,
    });
  };

  handleCheckBoxChange = (value: ProductShell): void => {
    const { selectedProducts } = this.state;

    this.setState({
      selectedProducts: handleCheckBox(selectedProducts, value),
    });
  };

  handleAddProducts = (): void => {
    this.setState((prevState: ProductSelectionState) => ({
      addProducts: !prevState.addProducts,
      errorSelectedProducts: false,
    }));
  };

  handleSubmit = (): void => {
    const { selectedProducts } = this.state;
    const { create, selectedDocument, selectedCompany } = this.props;

    const result = selectedProducts.every((product: ProductShell) => !product.error);

    if (!result) {
      return;
    }

    const data = computeSubmitData(selectedProducts, selectedDocument, selectedCompany);

    create(data);

    this.setState({
      errorSelectedProducts: false,
      selectedProducts: [],
    });
  };

  handleSetCommentProduct = (editorState: string, id: number): void => {
    const { selectedProducts } = this.state;
    const newSelectedProducts = selectedProducts.map((product: ProductShell) => {
      if (product.id === id) {
        product.workOrderComment = editorState;
      }
      return product;
    });

    this.setState({
      selectedProducts: newSelectedProducts,
    });
  };

  render(): ReactNode {
    const {
      isOpen,
      loadingList,
      loadingCreate,
      closeSelf,
    } = this.props;

    const {
      documents,
      errorSelectedProducts,
      selectedProducts,
      addProducts,
      dataTable,
    } = this.state;

    return (
      <ProductSelectionModal
        addProducts={addProducts}
        data={documents}
        dataTable={dataTable}
        errorSelectedProducts={errorSelectedProducts}
        isOpen={isOpen}
        loadingCreate={loadingCreate}
        loadingList={loadingList}
        message="deliveryNotProductMessage"
        path="/business/delivery_forms"
        selectedProducts={selectedProducts}
        title="deliveryCreate"
        closeSelf={closeSelf}
        handleAddProducts={this.handleAddProducts}
        handleInputChange={this.handleInputChange}
        handleCheckBoxChange={this.handleCheckBoxChange}
        handleSetCommentProduct={this.handleSetCommentProduct}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

const mapDispatchToProps = (dispatch: any): any => ({
  create: (data: {}): void => dispatch(create(data)),
  getList: (api: string): void => dispatch(getList(api)),

  closeSelf: (): void => dispatch(close()),
  reset(): void {
    dispatch(resetList());
    // tslint:disable-next-line:no-null-keyword
    dispatch(success(null));
  },
});

const mapStateToProps = (state: State): Partial<ProductSelectionProps<DeliveryForm>> => ({
  success: state.delivery.create.created,
  loadingCreate: state.delivery.create.loading,

  list: state.delivery.list.data,
  loadingList: state.delivery.list.loading,

  selectedDocument: state.userCompanies.select.selectedDocument,
  selectedCompany: state.userCompanies.select.selectedCompany,

  isOpen: state.modal.deliveryForm,
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryFormModal);
